var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar-layout"},[_vm._t("default"),_c('TabBar',{attrs:{"tabs":_vm.tabs}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }